import { render, staticRenderFns } from "./SubmitalLockCard.vue?vue&type=template&id=5c56ce46&scoped=true&"
import script from "./SubmitalLockCard.vue?vue&type=script&lang=js&"
export * from "./SubmitalLockCard.vue?vue&type=script&lang=js&"
import style0 from "./SubmitalLockCard.vue?vue&type=style&index=0&id=5c56ce46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c56ce46",
  null
  
)

export default component.exports